.toolbar {
  width: 1px;
  background-color: #eee;
}

.dropdown {
  width: auto;
  background-color: #eee;
  height: 1px;
}
